module.exports = __webpack_public_path__ + "img/10862_L.f8401e4a.png";